import type { Country } from '@/constants/config';

type ChatVendorDom = {
  readonly window: string;
  readonly otherRoots: readonly string[];
};

const CHAT_VENDOR_DOM = {
  SE: {
    window: 'iframe#webWidget',
    otherRoots: ['iframe#launcher'],
  },
  UK: {
    window: '#fc_frame',
    otherRoots: [],
  },
  FI: null,
} as const satisfies Record<Country, ChatVendorDom | null>;

export const CHAT_REPLAY_BLOCK_SELECTOR = Object.values(CHAT_VENDOR_DOM)
  .flatMap(vendor => (vendor === null ? [] : [vendor.window, ...vendor.otherRoots]))
  .join(', ');

export const FRESHCHAT_FRAME_SELECTOR = CHAT_VENDOR_DOM.UK.window;
